<template lang="html">


  <div id="area-tecnica--view" class="area-tecnica--view area-tecnica">

    <intro></intro>

    <section class="sec-center desc-area pad-sec">
      <div class="container waypoints" data="fadeInUp">
        <h2 class="title title-36">{{$t('area_tecnica.asesoramos.intro')}}</h2>
        <p>{{$t('area_tecnica.asesoramos.texto_1')}}</p> 
        <p>{{$t('area_tecnica.asesoramos.texto_2')}}<a href="https://wa.me/34619029273" target="_blank"><img src="/static/img/icono-whatsapp.webp" class="icono-whatsapp" alt=""></a>
</p>
        <a class="btn btn-dark btn-center -pink-full" href="mailto:customerservice@ajusa.es">{{$t('area_tecnica.asesoramos.boton')}}</a>
      </div>
    </section>

    <section :id="$t('area_tecnica.nav_options.ajusa_app.id')" class="app-mobile">

      <div class="container">

        <div class="texto">
          <h2 class="title title-36">AJUSA MOBILE APP</h2>
          <p>{{$t('area_tecnica.app.texto_1')}}</p>
          <p>{{$t('area_tecnica.app.texto_2')}}</p>
          <div class="botones">
            <a class="btn" href="https://apps.apple.com/es/app/ajusa-mobile/id1428469914" target="_blank">IOS</a>
            <a class="btn" :href="'https://play.google.com/store/apps/details?id=com.ajusa.app&hl=' + $i18n.locale" target="_blank">ANDROID</a>
          </div>
        </div>
        
        <div class="imagen">
          <img src="/static/img/mobile-ajusa.webp" alt="Mobile">
        </div>
      </div>
        
    </section>
    
    <tips-tecnicos :id="$t('area_tecnica.nav_options.tips.id')"></tips-tecnicos>

    <videos :intro="true" :id="$t('area_tecnica.nav_options.actualidad_videos.id')"></videos>

    <webinarios :id="$t('area_tecnica.nav_options.webinars.id')"></webinarios>

    <section class="asesoramiento sec-foto blue pad-sec">
      <div class="container waypoints flex row-reserve justify-start" data="fadeInLeft">
        <div class="col-50">
          <router-link :to="`${$t('enlaces.contacto')}/#reparacion`"></router-link>
          <h2 class="title-18">{{$t('area_tecnica.asesoramiento.intro')}}</h2>
          <h3 class="title title-52">{{$t('area_tecnica.asesoramiento.titulo')}}</h3>
          <p>{{$t('area_tecnica.asesoramiento.texto')}}</p>
          <p class="go">{{$t('area_tecnica.asesoramiento.boton')}}<i class="fa-sharp fa-solid fa-arrow-right-long" aria-hidden="true"></i></p>
        </div>
      </div>
    </section>

  <otras-secciones :data="['catalogo','actualidad']"></otras-secciones>


  </div>

</template>

<script lang="js">
  import Intro from '@/components/view-parts/intros/area-tecnica'
  import Otras_Secciones from '@/components/parts/acceso-a-secciones';
  import tips_tecnicos from '@/components/view-parts/area-tecnica/informes-tecnicos'
  import webinarios from '@/components/view-parts/area-tecnica/webinarios'
  import Videos from '@/components/view-parts/actualidad-parts/videos';
  export default  {
    name: 'area-tecnica',
    props: [],
    mounted() {
      let to = this.$route.params.id;

      if ($("#" + to).length > 0) {
        this.scrollTo(to);
      }

      if(window.innerWidth < 900) {
        const ele = document.getElementById('area-tecnica--view');
        const images = ele.getElementsByTagName('img');
        for(var i=0; i < images.length; i++) {
          var src = images[i].src.replace('/static/img','/static/img/responsive');
          images[i].src = src;
        }
      }
    },
    data() {
      return {

      }
    },
    methods: {
      scrollTo(to) {
        if ($("#" + to).length > 0) {
          $('body,html').animate({ scrollTop: $("#" + to).position().top }, 800);
        }
      }
    },
    components: {
      'intro' : Intro,
      'otras-secciones' : Otras_Secciones,
      'tips-tecnicos' : tips_tecnicos,
      'webinarios' : webinarios,
      'videos' : Videos,
    },
    watch: {
      "$route.params.id"(){
        this.scrollTo(this.$route.params.id);
      }
    },
  }
</script>

<style scoped>
.area-tecnica {

}
</style>



// WEBPACK FOOTER //
// src/components/views/area-tecnica.vue